export const METER_DATE_RULES = [
  {
    test: (v) => v.trim().length > 0,
    message: 'Date is required',
  },
  {
    test: (v) => v <= '2100-12-31',
    message: 'Date must be on or before 31 Dec 2100',
  },
];

export const METER_NUMBER_RULES = [
  {
    test: (v) => v.trim().length > 0,
    message: 'Meter number is required',
  },
  {
    test: (v) => v.trim().length <= 30,
    message: 'Meter number must be at most 30 characters',
  },
  {
    test: (v) => /^[A-Za-z0-9\-_]+$/.test(v.trim()),
    message: 'Meter number must contain only letters, numbers, hyphens and underscores',
  },
];

export const METER_COMMENTS_RULES = [
  {
    test: (v) => v.trim().length <= 255,
    message: 'Comments must be at most 255 characters',
  },
  {
    test: (v) => /^[A-Za-z0-9\-_.,\s]*$/.test(v.trim()),
    message: 'Comments must contain only letters, numbers, hyphens, underscores, full stops and commas',
  },
];
